// libs
import { styled } from '@nykaa/ui-components';

// animations
import {
  marqueeAnimation,
  marqueeGenerator,
  DEFAULT_MARQUE_SPEED,
} from 'shared/styles/animations/marquee';

// constants
import { FONTS, BREAKPOINTS, DWEB_MAX_WIDTH, DWEB_DISCOUNT_HEIGHT } from 'shared/styles/base';

const I18N_WIDGET_WIDTH = 200;
const DWEB_OFFER_WIDTH = DWEB_MAX_WIDTH - I18N_WIDGET_WIDTH * 2;

const DWEB_MARQUEE_ANIMATION = marqueeGenerator(`${DWEB_OFFER_WIDTH}px`);

export const BannerText = styled.span`
  width: 100%;
  ${({ theme }) => theme.typography.bodyLarge};
  font-family: ${FONTS.BASE_FAMILY};
  white-space: nowrap;
  overflow: hidden;
  color: #000;
  height: ${DWEB_DISCOUNT_HEIGHT}px;

  @media screen and (max-width: ${BREAKPOINTS.DESKTOP - 1}px) {
    ${({ theme }) => theme.typography.bodySmall};
    display: block;
    text-align: center;
    padding: 0 15px;
    height: 25px;
  }
`;

export const Container = styled.div`
  position: relative;
  color: #fff;
  width: ${DWEB_OFFER_WIDTH}px;
  height: ${DWEB_DISCOUNT_HEIGHT}px;
  overflow: hidden;

  @media screen and (max-width: ${BREAKPOINTS.DESKTOP - 1}px) {
    display: block;
    width: 100%;
    height: 25px;
  }

  .bannerText {
    position: absolute;
    left: 0;
    top: 0;
    width: auto;
    overflow: initial;
    color: #fff;
    animation: ${DWEB_MARQUEE_ANIMATION} ${DEFAULT_MARQUE_SPEED}s linear infinite;

    @media screen and (max-width: ${BREAKPOINTS.DESKTOP - 1}px) {
      ${marqueeAnimation}
    }
  }
`;

export const Anchor = styled(Container.withComponent('a'))`
  display: block;
  text-decoration: none;
`;
